
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("calendar/calendarmenuitem",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow class=\"border-pane\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" data-fw-onclick=\"calediterror|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><icon data-fw-onclick=\"caledit|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"color:var(--red)\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_error",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":192},"end":{"line":1,"column":214}}}))
    + "</icon><flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</line><line class=\"sub4\" style=\"color:var(--red)\"> "
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"calendars.calerror.subtitle",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":299},"end":{"line":1,"column":337}}}))
    + " </line></flexauto><icon data-fw-onclick=\"caledit|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"color:var(--fwTextSecondary)\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_chevron_right",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":438},"end":{"line":1,"column":468}}}))
    + "</icon></flexrow> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " <flexrow class=\"border-pane\" ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"clickaction") || (depth0 != null ? lookupProperty(depth0,"clickaction") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"clickaction","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":524},"end":{"line":1,"column":579}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"clickaction")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"activated") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":581},"end":{"line":1,"column":747}}})) != null ? stack1 : "")
    + " <flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</line><line class=\"sub4\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"subtitlewithsub") : depth0), depth0))
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mine") : depth0),{"name":"unless","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":822},"end":{"line":1,"column":866}}})) != null ? stack1 : "")
    + " </line></flexauto><icon data-fw-onclick=\"caledit|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"color:var(--fwTextSecondary)\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_chevron_right",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":967},"end":{"line":1,"column":997}}}))
    + "</icon></flexrow> ";
},"4":function(container,depth0,helpers,partials,data) {
    return "data-fw-onclick=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<icon style=\"color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"colorUI") : depth0), depth0))
    + ";\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_checked",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":633},"end":{"line":1,"column":657}}}))
    + "</icon> ";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<icon style=\"color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"colorUI") : depth0), depth0))
    + ";\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_checkbox",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":708},"end":{"line":1,"column":733}}}))
    + "</icon>";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " - "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"sharedBy") : depth0), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"errorCode") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":1022}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;